import { combineRules } from 'fela';

import type { Theme, TRuleWithTheme } from '@/styles/theme';

export enum LinkType {
    ROUTER = 'router',
    NATIVE = 'native',
}

export enum LinkSize {
    BIG = 'big',
    REGULAR = 'regular',
    SMALL = 'small',
}

const SIZE_TOKEN = {
    [LinkSize.BIG]: 'LinkLarge',
    [LinkSize.REGULAR]: 'LinkMedium',
    [LinkSize.SMALL]: 'LinkSmall',
} as const satisfies Record<LinkSize, keyof Theme['typography']>;

export const container: TRuleWithTheme<{
    color?: keyof Theme['colors'];
    size?: `${LinkSize}`;
    inheritColor?: boolean;
}> = ({ theme, size, color = 'blue', inheritColor }) => ({
    ...(size && theme.typography[SIZE_TOKEN[size]]),

    color: inheritColor ? 'inherit' : theme.colors[color],

    ':hover': {
        textDecoration: 'none',
        color: inheritColor ? 'inherit' : theme.colors[color],
    },
});

export const externalLink: TRuleWithTheme = combineRules(container, ({ theme }) => ({
    textDecoration: 'underline',
}));
